var _defs, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnTt0V7Twvieay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#050505;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24,
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.33,8.69A4.38,4.38,0,0,1,16.08,9a2.18,2.18,0,0,0,1-1.21,4.4,4.4,0,0,1-1.39.53,2.19,2.19,0,0,0-3.79,1.49,2,2,0,0,0,.06.5A6.21,6.21,0,0,1,7.41,8.07,2.18,2.18,0,0,0,8.09,11a2.14,2.14,0,0,1-1-.28v0a2.2,2.2,0,0,0,1.76,2.15,2.2,2.2,0,0,1-.58.07,1.9,1.9,0,0,1-.41,0,2.21,2.21,0,0,0,2.05,1.53,4.45,4.45,0,0,1-3.24.9,6.23,6.23,0,0,0,9.58-5.24,2.81,2.81,0,0,0,0-.29A4.19,4.19,0,0,0,17.33,8.69Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnTt0V7Twvieay);
export default __webpack_public_path__ + "static/media/sn-tt-0v7twvieay.6050857de1f2b1caf160eaa4c843ca96.svg";
export { ForwardRef as ReactComponent };